import { redirectToBackofficeV1 } from '@/utils/backoffice-v1';

export const redirectToCustomerInformationPage = (customerId: string, tab: string): void => {
    const customerInformationPagePath = `/home/customers/${customerId}/${tab}`;
    redirectToBackofficeV1(customerInformationPagePath);
};
